import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-error-response',
    imports: [],
    templateUrl: './not-actionable.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './not-actionable.component.scss',
})
export class NotActionableComponent {
    private readonly activatedRoute = inject(ActivatedRoute);
    errorMessage: string;

    ngOnInit(): void {}
}
